import { Component, OnInit } from '@angular/core';
import { AiModelPricingModel, ArkUserType } from '../../core/api/models';
import { AiUsageApiService } from '../../core/api/services';
import { Utils } from '../../core/utils';
import { AuthService } from '../../main/auth.service';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-ai-model-pricing',
  templateUrl: './ai-model-pricing.component.html',
  standalone: false
})
export class AIModelPricingComponent implements OnInit {
  models: AiModelPricingModel[] = [];
  loading = true;

  constructor(
    private authService: AuthService,
    private alertService: AlertService,
    private apiService: AiUsageApiService) {
  }

  ngOnInit(): void {
    this.authService.checkIfAutorized([ArkUserType.Admin]);
    this.load();
  }

  save(): void {
    if (this.loading) return;
    this.loading = true;
    this.apiService.SaveModelPricing({ body: { Models: this.models } }).subscribe({
      next: result => {
        this.models = result.Models || [];
        this.loading = false;
        this.alertService.success('AI model pricing saved successfully');
      },
      error: err => {
        this.loading = false;
        this.alertService.error(Utils.getAjaxError(err));
      }
    });
  }

  private load(): void {
    this.loading = true;
    this.apiService.GetModelPricing().subscribe({
      next: result => {
        this.models = result.Models || [];
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this.alertService.error(Utils.getAjaxError(err));
      }
    });
  }
}
